import Vue from 'vue'
import VueI18n from 'vue-i18n'
import LanguageApi from "@/core/modules/LanguageApi";
import LanguageService from "@/services/LanguageService";

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const languageApi = new LanguageApi();

async function getMessagesFromDatabase() {
  try {
    
    const languages = await languageApi.getAllLanguages();
    const messages = {};

    for (const key in languages) {
      messages[key] = languages[key];
    }

    return messages;
  } catch (error) {
    console.error("Hata:", error);
    return {};
  }
}

async function getMessagesFromLanguageService() {
  return await LanguageService.panelLanguage().then(({ data }) => data);
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  // messages: async () => await getMessagesFromLanguageService()
})
